import {useMutation, useQuery} from '@tanstack/react-query';
import axiosClient from '../services/axiosClient';

export const useGetQuestionsQuery = (params) => {
  return useQuery(['questions', params], async () => {
    const {data} = await axiosClient.get('/questions', {
      params,
    });
    return data;
  });
};

export const useGetQuestionDetailsQuery = (questionId) => {
  return useQuery(
    [questionId],
    async () => {
      const {data} = await axiosClient.get(`/question/${questionId}`);
      return data;
    },
    {
      enabled: !!questionId,
      keepPreviousData: false,
      cacheTime: 0,
    },
  );
};

export const useAddQuestionMutation = () =>
  useMutation(async (payload) => {
    const {data} = await axiosClient.post('/question', payload);
    return data;
  });

export const useUpdateQuestionMutation = () =>
  useMutation(async ({questionId, ...payload}) => {
    const {data} = await axiosClient.patch(`question/${questionId}`, payload);
    return data;
  });

export const useDeleteQuestionMutation = () =>
  useMutation(async (questionsIds) => {
    const {data} = await axiosClient.delete('question', {
      data: {
        questionsIds,
      },
    });
    return data;
  });

export const useUploadBulkQuestionsMutation = () =>
  useMutation(async (payload) => {
    const {data} = await axiosClient.post('/question/bulkUpload', payload);
    return data;
  });

/**
 *
 * Subject CRUD
 *
 */

export const useGetSubjectsQuery = (params) => {
  return useQuery(['subjects', params], async () => {
    const {data} = await axiosClient.get('/testSubject', {
      params,
    });
    return data;
  });
};

export const useGetSubjectListQuery = (queryEnabled = true) => {
  return useQuery(
    ['subjectList'],
    async () => {
      const {data} = await axiosClient.get('/testSubject/list');
      return data;
    },
    {enabled: queryEnabled},
  );
};

export const useAddSubjectMutation = () =>
  useMutation(async (payload) => {
    const {data} = await axiosClient.post('testSubject', payload);
    return data;
  });

export const useUpdateSubjectMutation = () =>
  useMutation(async ({subjectId, ...payload}) => {
    const {data} = await axiosClient.patch(`testSubject/${subjectId}`, payload);
    return data;
  });

export const useDeleteSubjectMutation = () =>
  useMutation(async (subjectId) => {
    const {data} = await axiosClient.delete(`testSubject/${subjectId}`);
    return data;
  });
